export default __webpack_public_path__ + "static/media/american-express-logo.e643165f.png";